import { CheckStatus, Parse } from '../utils/ajax';

export default {

    get(id, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/graph/flow/${id}`, {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    save(id, graph, tenantId, authenticationToken) {
        return fetch('/api/draw/1/graph/flow', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
            body: JSON.stringify(graph),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getMapElements(flowId, editingToken, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${flowId}/${editingToken}/element/map/`, {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getGroupElements(flowId, editingToken, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${flowId}/${editingToken}/element/group/`, {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getMapElement(id, flowId, editingToken, elementType, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${flowId}/${editingToken}/element/${elementType}/${id}`, {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    saveMapElement(request, flowId, editingToken, elementType, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${flowId}/${editingToken}/element/${elementType}`, {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
            body: JSON.stringify(request),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    deleteGroupElement(id, flowId, editingToken, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${flowId}/${editingToken}/element/group/${id}`, {
            method: 'DELETE',
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    deleteMapElement(id, flowId, editingToken, elementType, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${flowId}/${editingToken}/element/${elementType}/${id}`, {
            method: 'delete',
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

};
